export default __webpack_public_path__ + "static/subset-UniNeueBold-e6dae7fbe72d49897e8746ee284e0624.woff";